export default "__VITE_ASSET__Cf8O5YG___"